import { useState } from 'react'
import Header from '../../../../googleAd/shared/sections/Header'
import Annotation from '../../../../googleAd/shared/sections/FirstView/Annotation'
import VerticalEntryForm from '../../../shared/forms/VerticalEntryForm'
import instagramConfig from './config'
import { StepProvider } from '@/components/Context/StepContext'
import styles from './InstagramAllRegionFormPage.module.css'
import { AllRegionSpLandingPageProps } from './types'
import { useAbTestGtm } from '@/components/utils/abTest'
import { isCafeCreativeInflow } from '@/components/utils/cafeFirstViewTargeting'
import { SlimFirstView } from '@/components/Common/SlimFirstView'
import { CafeFirstView } from '@/components/Common/CafeFirstView'
import { CompanyLogoStrip } from '@/components/Common/CompanyLogoStrip'

const InstagramAllRegionFormPage: React.FC<AllRegionSpLandingPageProps> = ({ prefectures }) => {
    const { dataViewLabel } = useAbTestGtm()
    // URLだけで決まるので初回レンダーで同期的に判定できる（判定待ちで一瞬別のFVが出ることがない）。
    // マウント時点の値に固定する。このコンポーネントは useAbTestGtm の isClient 確定で必ず
    // 1回再レンダーされるため、固定しないと毎回 window.location を読み直すことになる。
    // useMemo はキャッシュが捨てられうる（Reactの仕様上は最適化であって保証ではない）ので、
    // 固定を保証できる useState の遅延初期化を使う
    const [isCafeCreative] = useState(() =>
        isCafeCreativeInflow(window.location.pathname, window.location.search)
    )

    return(
        <div className={styles.InstagramAllRegionFormPageWrap}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header id='renewal_top' dataViewLabel={dataViewLabel('HD')} />
                {/* DEV-3390→DEV-3574: カフェ訴求クリエイティブからの流入だけFVを差し替える。
                    それ以外の流入は現行の帯FVのまま。対象の条件は
                    utils/cafeFirstViewTargeting.ts を参照 */}
                {isCafeCreative ? (
                    <CafeFirstView dataViewLabel={dataViewLabel('CT_FirstView')} />
                ) : (
                    <SlimFirstView dataViewLabel={dataViewLabel('CT_FirstView')} />
                )}
                <CompanyLogoStrip />
                <div className={styles.formWrap}>
                    <VerticalEntryForm
                        prefectures={prefectures}
                        config={instagramConfig}
                    />
                    {/* DEV-3366→DEV-3419: 帯画像には「求人数No.1※」が入るが、旧FV画像内にあった
                        調査注記は消えるため、googleAdと同じ内容の注記をここで補う
                        （DEV-3102/DEV-3239でFV差し替え時に注記を足したのと同じ扱い） */}
                    <Annotation />
                </div>
            </StepProvider>
        </div>
    )
}

export default InstagramAllRegionFormPage
